import { api } from '@/lib/api'
import type {
  ReinvestSuggestion,
  SimulationCommitResponse,
  SimulationInput,
  SimulationResult,
} from '@/types/simulation'

export async function fetchSimulationPreview(inputs: SimulationInput): Promise<SimulationResult> {
  const response = await api.post('/simulations/preview', inputs)
  return response.data
}

export async function fetchSimulationQuickFill(params: {
  sell_position_id: number
  amount_eur: string
}): Promise<ReinvestSuggestion[]> {
  const response = await api.get('/simulations/quick-fill', {
    params: {
      sell_position_id: params.sell_position_id,
      amount_eur: params.amount_eur,
    },
  })
  return response.data.suggestions
}

export async function commitSimulation(inputs: SimulationInput): Promise<SimulationCommitResponse> {
  const response = await api.post('/simulations', inputs)
  return response.data
}
